import React from "react";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import { useSelector } from "react-redux";
import Errormsg from "@frameworks/shared-library/components/errorMsg";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/shared-library/components/ErrorNotification";
var PasswordReset = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var passwordHistory = useSelector(function (state) { return state.Clients.PasswordResentHistory.reducersData.data; });
    var passwordHistoryCommon = useSelector(function (state) { return state.Clients.PasswordResentHistory.commonData; });
    var passwordColumns = [
        {
            columnName: "Date",
            key: "date",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Website",
            key: "website",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Transaction",
            key: "transaction",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
    ];
    return (React.createElement(React.Fragment, null,
        passwordHistoryCommon.errorData &&
            ((_a = passwordHistoryCommon.errorData) === null || _a === void 0 ? void 0 : _a.isOpen) && (React.createElement(ErrorNotification, { error: (_b = passwordHistoryCommon === null || passwordHistoryCommon === void 0 ? void 0 : passwordHistoryCommon.errorData) === null || _b === void 0 ? void 0 : _b.error, isOpen: (_c = passwordHistoryCommon === null || passwordHistoryCommon === void 0 ? void 0 : passwordHistoryCommon.errorData) === null || _c === void 0 ? void 0 : _c.isOpen, displayType: ErrorDisplayType.INSECTION, refresh: function () { } })),
        !((_d = passwordHistoryCommon === null || passwordHistoryCommon === void 0 ? void 0 : passwordHistoryCommon.errorData) === null || _d === void 0 ? void 0 : _d.isOpen) && (React.createElement(React.Fragment, null,
            React.createElement(GenericTable, { columns: passwordColumns, data: passwordHistory, loader: passwordHistoryCommon.loader, parentClassName: "password-reset-table" }),
            React.createElement("div", { className: "Errormsgdiv" }, (passwordHistoryCommon === null || passwordHistoryCommon === void 0 ? void 0 : passwordHistoryCommon.message) &&
                ((_e = passwordHistoryCommon === null || passwordHistoryCommon === void 0 ? void 0 : passwordHistoryCommon.message) === null || _e === void 0 ? void 0 : _e.show) && (React.createElement(Errormsg, { icon: (_f = passwordHistoryCommon === null || passwordHistoryCommon === void 0 ? void 0 : passwordHistoryCommon.message) === null || _f === void 0 ? void 0 : _f.icon, msg: (_g = passwordHistoryCommon === null || passwordHistoryCommon === void 0 ? void 0 : passwordHistoryCommon.message) === null || _g === void 0 ? void 0 : _g.msg })))))));
};
export default PasswordReset;
